export const categories = [
  {
    name: "Shoes",
    icon: "ri-footprint-line",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    description: "Compare sneakers, boots, and footwear from top brands with real value scores.",
    imageUrl: "https://readdy.ai/api/search-image?query=Clean%20white%20sneakers%20flat%20lay%20on%20warm%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20simple%20background%2C%20fresh%20aesthetic&width=400&height=320&seq=cat-img-shoes&orientation=landscape",
  },
  {
    name: "Hoodies / Sweaters",
    icon: "ri-t-shirt-line",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    description: "Find the best hoodies and sweaters ranked by quality, price, and style.",
    imageUrl: "https://readdy.ai/api/search-image?query=Cozy%20oversized%20knit%20sweater%20draped%20on%20wooden%20chair%2C%20warm%20cream%20wall%20background%2C%20soft%20window%20light%2C%20editorial%20fashion%20photography%2C%20natural%20textures%2C%20clean%20composition&width=400&height=320&seq=cat-img-hoodies&orientation=landscape",
  },
  {
    name: "T-Shirts",
    icon: "ri-shirt-line",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    description: "Browse curated t-shirt comparisons across fabrics, fits, and price points.",
    imageUrl: "https://readdy.ai/api/search-image?query=Folded%20cotton%20t-shirts%20stacked%20neatly%20on%20light%20wood%20shelf%2C%20warm%20neutral%20backdrop%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20retail%20aesthetic&width=400&height=320&seq=cat-img-tshirts&orientation=landscape",
  },
  {
    name: "Jackets",
    icon: "ri-t-shirt-2-line",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    description: "Winter coats, bombers, and lightweight jackets compared side by side.",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20bomber%20jacket%20hanging%20on%20minimal%20wooden%20hanger%2C%20warm%20beige%20wall%20background%2C%20soft%20natural%20light%2C%20editorial%20fashion%20photography%2C%20clean%20simple%20aesthetic&width=400&height=320&seq=cat-img-jackets&orientation=landscape",
  },
  {
    name: "Pants / Shorts",
    icon: "ri-pantone-line",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    description: "Jeans, chinos, cargo pants and shorts with detailed fit breakdowns.",
    imageUrl: "https://readdy.ai/api/search-image?query=Well%20folded%20denim%20jeans%20stacked%20on%20cream%20linen%20surface%2C%20warm%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20clean%20editorial%20style%2C%20soft%20shadows&width=400&height=320&seq=cat-img-pants&orientation=landscape",
  },
  {
    name: "Headwear",
    icon: "ri-customer-service-2-line",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    description: "Caps, beanies, and hats from streetwear to luxury brands.",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20baseball%20cap%20placed%20on%20clean%20white%20surface%2C%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20editorial%20fashion%20aesthetic&width=400&height=320&seq=cat-img-headwear&orientation=landscape",
  },
  {
    name: "Sets",
    icon: "ri-stack-line",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    description: "Coordinated outfit sets and matching pieces for effortless styling.",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20outfit%20set%20laid%20flat%20on%20cream%20linen%2C%20matching%20top%20and%20bottom%2C%20warm%20natural%20light%2C%20editorial%20fashion%20photography%2C%20clean%20simple%20composition&width=400&height=320&seq=cat-img-sets&orientation=landscape",
  },
  {
    name: "Underwear / Underpants",
    icon: "ri-heart-line",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    description: "Comfort-focused underwear comparisons with fabric and fit ratings.",
    imageUrl: "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20neatly%20folded%20on%20warm%20cream%20surface%2C%20minimalist%20product%20photography%2C%20gentle%20natural%20lighting%2C%20clean%20simple%20aesthetic%2C%20editorial%20style&width=400&height=320&seq=cat-img-underwear&orientation=landscape",
  },
  {
    name: "Jersey",
    icon: "ri-vip-crown-line",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    description: "Sports jerseys and athletic wear with authentic brand comparisons.",
    imageUrl: "https://readdy.ai/api/search-image?query=Sports%20jersey%20hanging%20on%20minimal%20wooden%20hanger%2C%20warm%20cream%20wall%20background%2C%20soft%20studio%20lighting%2C%20editorial%20athletic%20photography%2C%20clean%20sporty%20aesthetic&width=400&height=320&seq=cat-img-jersey&orientation=landscape",
  },
  {
    name: "Accessories",
    icon: "ri-glasses-line",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    description: "Watches, sunglasses, jewelry and more — all compared transparently.",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20sunglasses%20and%20watch%20arranged%20on%20cream%20linen%20surface%2C%20warm%20natural%20lighting%2C%20editorial%20product%20photography%2C%20minimalist%20composition%2C%20lifestyle%20aesthetic&width=400&height=320&seq=cat-img-accessories&orientation=landscape",
  },
  {
    name: "Bags",
    icon: "ri-briefcase-line",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    description: "Backpacks, totes, and crossbody bags ranked by durability and design.",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20leather%20backpack%20placed%20on%20clean%20cream%20surface%2C%20warm%20natural%20light%2C%20minimalist%20product%20photography%2C%20editorial%20fashion%20style%2C%20simple%20background&width=400&height=320&seq=cat-img-bags&orientation=landscape",
  },
  {
    name: "Belts",
    icon: "ri-link",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    description: "Leather belts, casual belts, and designer options at every price tier.",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20leather%20belt%20coiled%20on%20warm%20cream%20surface%2C%20soft%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20editorial%20fashion%20detail%2C%20clean%20elegant%20aesthetic&width=400&height=320&seq=cat-img-belts&orientation=landscape",
  },
  {
    name: "Perfumes",
    icon: "ri-contrast-drop-line",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    description: "Fragrance comparisons with scent profiles, longevity, and value analysis.",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottle%20on%20cream%20marble%20surface%2C%20warm%20natural%20lighting%2C%20editorial%20product%20photography%2C%20minimalist%20luxury%20aesthetic%2C%20soft%20shadows%2C%20clean%20composition&width=400&height=320&seq=cat-img-perfumes&orientation=landscape",
  },
  {
    name: "Other Stuff",
    icon: "ri-more-line",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    description: "Everything else worth comparing — electronics, home goods, and more.",
    imageUrl: "https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20products%20arranged%20on%20cream%20surface%2C%20electronics%20and%20home%20items%2C%20warm%20natural%20lighting%2C%20editorial%20product%20photography%2C%20clean%20minimalist%20composition&width=400&height=320&seq=cat-img-other&orientation=landscape",
  },
];

export const trendingItems = [
  {
    name: "Air Force 1 Low",
    price: "From $89",
    badge: "HOT",
    imageUrl: "https://readdy.ai/api/search-image?query=Classic%20white%20leather%20sneakers%20on%20warm%20cream%20studio%20backdrop%2C%20side%20profile%20view%2C%20soft%20natural%20lighting%2C%20product%20photography%2C%20crisp%20clean%20details%2C%20editorial%20fashion%20shot&width=600&height=750&seq=trend-0-af1-v2&orientation=portrait",
  },
  {
    name: "Essential Hoodie",
    price: "From $45",
    badge: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20heather%20grey%20hoodie%20front%20view%20on%20cream%20surface%2C%20minimalist%20product%20photography%2C%20soft%20diffused%20lighting%2C%20clean%20editorial%20style%2C%20textured%20fabric%20visible&width=600&height=750&seq=trend-1-hood-v2&orientation=portrait",
  },
  {
    name: "Classic Graphic Tee",
    price: "From $25",
    badge: "",
    imageUrl: "https://readdy.ai/api/search-image?query=Black%20cotton%20t-shirt%20flat%20lay%20on%20warm%20cream%20textured%20surface%2C%20clean%20studio%20lighting%2C%20minimalist%20product%20photography%2C%20editorial%20fashion%20style%2C%20soft%20contrast&width=600&height=750&seq=trend-2-tee-v2&orientation=portrait",
  },
  {
    name: "Varsity Jacket",
    price: "From $110",
    badge: "NEW",
    imageUrl: "https://readdy.ai/api/search-image?query=Varsity%20letterman%20jacket%20in%20forest%20green%20and%20cream%20on%20minimal%20studio%20backdrop%2C%20product%20photography%2C%20soft%20natural%20lighting%2C%20front%20view%2C%20clean%20editorial%20composition&width=600&height=750&seq=trend-3-jack-v2&orientation=portrait",
  },
];

export const testimonials = [
  {
    name: "Marcus J.",
    role: "Fashion Enthusiast",
    text: "The spreadsheet saved me hours of comparing sneakers. Found exactly what I wanted at the right price without scrolling endlessly.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Young%20stylish%20man%20portrait%20with%20warm%20golden%20lighting%2C%20cream%20studio%20background%2C%20editorial%20headshot%20photography%2C%20friendly%20natural%20smile%2C%20professional%20portrait&width=80&height=80&seq=test-av-0-v2&orientation=squarish",
  },
  {
    name: "Elena R.",
    role: "Online Shopper",
    text: "I used to jump between ten tabs comparing hoodies. Now one Pandabuy Sheet link gives me everything I need. Absolute game changer.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Fashionable%20woman%20portrait%20in%20soft%20window%20light%2C%20warm%20cream%20backdrop%2C%20editorial%20headshot%20photography%2C%20genuine%20smile%2C%20minimalist%20composition%2C%20natural%20beauty&width=80&height=80&seq=test-av-1-v2&orientation=squarish",
  },
  {
    name: "David K.",
    role: "Reseller",
    text: "For finding the best value items across categories, nothing beats the organized data in this spreadsheet. I check it daily.",
    avatarUrl: "https://readdy.ai/api/search-image?query=Professional%20man%20headshot%20with%20warm%20ambient%20studio%20lighting%2C%20cream%20background%2C%20editorial%20portrait%20photography%2C%20confident%20but%20approachable%20expression&width=80&height=80&seq=test-av-2-v2&orientation=squarish",
  },
];